// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_mh-0";
export var discountCodeInput = "_mh-1";